import axios, { type AxiosInstance, type AxiosResponse } from 'axios'

/** 로컬 실행과 dev 배포본에서만 API 응답 로그를 노출한다. */
function shouldLogApiResponses(): boolean {
  return import.meta.env.MODE === 'development' || import.meta.env.MODE === 'local'
}

/** presigned URL 등의 민감한 query string 은 콘솔 라벨에 남기지 않는다. */
function responseLabel(response: AxiosResponse): string {
  const method = response.config.method?.toUpperCase() ?? 'REQUEST'
  const url = (response.config.url ?? '').split('?')[0]
  return `[API response] ${method} ${url} (${response.status})`
}

/**
 * Axios 인스턴스의 성공·실패 응답 데이터를 개발자 콘솔에 출력한다.
 * 요청 헤더와 query string 은 토큰·서명 노출을 피하기 위해 출력하지 않는다.
 */
export function attachApiResponseLogger(client: AxiosInstance): void {
  if (!shouldLogApiResponses()) return

  client.interceptors.response.use(
    (response) => {
      console.log(responseLabel(response), response.data)
      return response
    },
    (error: unknown) => {
      if (axios.isAxiosError(error) && error.response) {
        console.error(responseLabel(error.response), error.response.data)
      }
      return Promise.reject(error)
    }
  )
}
